// extracted by mini-css-extract-plugin
module.exports = {"scroll-btn":"ScrollToTopButton_scroll-btn__n_7Oj","scroll-btn__icon":"ScrollToTopButton_scroll-btn__icon__XtDW7"};